<template>
  <div class="customer-edit-invoices">
    <customer-show-quotation ref="showquotation" :customer="customer" :clinic="clinic"
      @submit="onSubmit"></customer-show-quotation>
    <customer-show-payment ref="showpayment" :customer="customer" @submit="onSubmit"></customer-show-payment>
    <customer-show-payment-mult ref="showpaymentmult" :customer="customer"
      @submit="onSubmit"></customer-show-payment-mult>
    <customer-show-invoice ref="showinvoice" :customer="customer" :clinic="clinic"
      @submit="onSubmit"></customer-show-invoice>
    <div class="customer-edit-invoices__quotations">



      <div class="row my-3" v-if="show_clinic_selector">
        <div class="col-3 d-flex">
          <legend>Clínica:</legend>
          <select v-model="clinic_id" id="customer_invoices_clinic_id" class="custom-select wabident-xsmall mx-2">
            <option :value="null">Todas</option>
            <option v-for="(name, index) in clinics" :key="index" :value="index">
              {{ name }}
            </option>
          </select>
        </div>
      </div>

      <div class="row my-3">
        <div class="col">
          <button type="button" @click="addQuotation" class="btn btn-primary btn-wabident btn-plus float-right">
            <i class="fas fa-plus"></i>
          </button>
          <legend>
            Presupuestos
          </legend>
          <div class="quotation-list">
            <customer-quotation v-for="q in filtered_quotations" :key="q.id" :quotation="q" :customer="customer"
              @edit="editQuotation" @approve="approveQuotation"></customer-quotation>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!agenda_only" class="customer-edit-invoices__pending">
      <div class="row">
        <div class="col d-flex flex-row align-items-center" style="margin-bottom: 15px">
          <div class="flex-fill">
            <div v-if="is_core" class="summary-header">SALDO</div>
            <div v-else class="summary-header">PENDIENTE DE PAGO</div>
            <div class="total-quoted">
              Total presupuestado: {{ pretty_quoted }}<br />
              Total realizado: {{ pretty_done }}<br />
              Total pagado: {{ pretty_paid }}
            </div>
          </div>
          <div>
            <a role="button" target="_blank" :href="customer_payment_report_link"
              class="btn btn-primary btn-wabident mx-3">Informe <i class="fas fa-print"></i>
            </a>
          </div>
          <div class="total-pending">
            {{ pretty_pending }}
            <sup v-if="is_core">
              <i class="fas fa-question-circle" data-trigger="tooltip" title="Saldo = Pagado - Realizado"></i>
            </sup>
          </div>
        </div>
      </div>

      <div class="row treatments my-2">
        <div class="col">
          <transition name="fade">
            <button v-if="has_pending_treatments" type="button" class="btn btn-primary btn-wabident-round float-right"
              @click="payAllTreatments">
              PAGAR SELECIONADOS
            </button>
          </transition>
          <legend class="mb-4">Tratamientos pendientes</legend>
          <div class="treatment-list">
            <template v-for="(treatment, index) in data.pending_treatments">
              <treatment-item :selectable="true" :selected="isTreatmentSelected(treatment)"
                :total="getTreatmentTotal(treatment)" :key="index" :clinics="clinics" :treatment="treatment"
                :clinic_type="clinic.type" :show_done="true" @paid="paidTreatment" @select="selectedTreatment"
                @done="doneTreatment"></treatment-item>
            </template>
          </div>
        </div>
      </div>

      <div class="row invoices my-2">
        <div class="col">
          <button type="button" class="btn btn-primary btn-wabident-round float-right mb-2" @click="addPayment">
            Crear <span v-if="is_dental">Pago</span><span v-else>Cobro</span>&nbsp;
            <i class="fas fa-plus"></i>
          </button>

          <div class="d-flex d-flex-row align-items-center mb-4">
            <legend class="mr-4">Entregas a cuenta</legend>
            <select id="customer_payments_filter_payments" v-model="filter_payments" style="max-width: 150px"
              class="custom-select size-s">
              <option :value="null">Todos</option>
              <option value="invoiced">Facturados</option>
              <option value="not_invoiced">Sin facturar</option>
            </select>
          </div>

          <div class="invoice-list">
            <customer-payment v-for="p in filtered_payments" :customer="customer" :payment="p" :key="p.id"
              @click="editPayment"></customer-payment>
          </div>
        </div>
      </div>

      <div v-if="can_invoice" class="row invoices my-2">
        <div class="col">
          <button type="button" class="btn btn-primary btn-wabident-round float-right mb-2" @click="addInvoice">
            Crear Factura&nbsp;
            <i class="fas fa-plus"></i>
          </button>

          <div class="d-flex d-flex-row align-items-center mb-4">
            <legend class="mr-4">Facturas</legend>
            <select id="customer_invoices_filter_invoices" v-model="filter_invoices" style="max-width: 150px"
              class="custom-select size-s">
              <option :value="null">Todas</option>
              <option value="paid">Pagadas</option>
              <option value="not_paid">Sin pagar</option>
              <option value="rectified">Rectificadas</option>
            </select>
          </div>

          <div class="invoice-list">
            <customer-invoice v-for="i in filtered_invoices" :customer="customer" :invoice="i" :key="i.id"
              @edit="editInvoice"></customer-invoice>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["customer"],
  data() {
    return {
      is_loading: false,
      selected_treatments: [],
      filter_invoices: null,
      filter_payments: null,
      clinic_id: null,
      data: {
        quotations: [],
        invoices: [],
        payments: [],
        available_treatments: [],
        pending_treatments: [],
        total_quoted: 0,
        total_pending: 0,
      },
    };
  },
  watch: {
    clinic_id(val) {
      this.loadData();
    },
  },
  computed: {
    agenda_only() {
      return this.clinic && this.clinic.capabilities.agenda_only;
    },
    unified_invoices() {
      return this.clinic && this.clinic.config.customer_unified_invoices;
    },
    show_clinic_selector() {
      return this.unified_invoices && (Object.keys(this.clinics).length > 1);
    },
    filtered_payments() {
      return this.data.payments.filter((payment) => {
        switch (this.filter_payments) {
          case "invoiced":
            return payment.invoice_id !== null;
          case "not_invoiced":
            return payment.invoice_id === null;
          default:
            return true;
        }
      });
    },
    filtered_invoices() {
      return this.data.invoices.filter((invoice) => {
        switch (this.filter_invoices) {
          case "paid":
            return invoice.is_paid && !invoice.is_revoked;
          case "not_paid":
            return !invoice.is_paid && !invoice.is_revoked;
          case "rectified":
            return Boolean(invoice.is_revoked);
          default:
            return true;
        }
      });
    },
    is_dental() {
      if (!this.clinic) return true;
      return this.clinic.type == "dental";
    },
    has_pending_treatments() {
      if (this.is_loading) return false;
      if (!this.selected_treatments) return false;
      return this.selected_treatments.length > 0;
    },
    customer_payment_report_link() {
      if (!this.customer) return "";

      return `/customer/${this.customer.id}/payments_report`;
    },
    pretty_quoted() {
      return WabiDent.fmtMoney(this.data.total_quoted, 0);
    },
    pretty_paid() {
      return WabiDent.fmtMoney(this.data.total_paid, 0);
    },
    pretty_done() {
      return WabiDent.fmtMoney(this.data.total_done, 0);
    },
    pretty_pending() {
      if (this.is_core) {
        let pending = this.data.total_paid - this.data.total_done;
        if (Math.abs(pending) < 0.01) {
          pending = 0;
        }
        return WabiDent.fmtMoney(pending, 0);
      }

      let pending = this.data.total_pending;
      if (Math.abs(pending) < 0.01) {
        pending = 0;
      }

      return WabiDent.fmtMoney(pending, 0);
    },
    filtered_quotations() {
      return this.data.quotations;
    },
    clinics() {
      if (!this.clinic) return [];
      return this.clinic.clinic_names;
    },
    can_invoice() {
      return true;
    },
    done_warning() {
      if (this.clinic && this.clinic.type == "dental") {
        return "¡El tratamiento viene hecho de otra clínica!";
      } else return "¡El tratamiento es una revisión!";
    },
    ...mapGetters(["msgwindow", "errorwindow", "clinic_config", "clinic", "is_core"]),
  },
  methods: {
    isTreatmentSelected(treatment) {
      return Boolean(
        this.selected_treatments.find((t) => {
          return t.id == treatment.id;
        })
      );
    },
    selectedTreatment(treatment, selected) {
      if (selected) {
        this.selected_treatments.push(treatment);
      } else {
        this.selected_treatments = this.selected_treatments.filter((item) => {
          return item.id != treatment.id;
        });
      }
    },
    userCan(capability) {
      if (!this.clinic) return false;
      return this.clinic.capabilities[capability] || false;
    },
    addQuotation() {
      if (this.data.available_treatments.length <= 0) {
        this.errorwindow.show(
          "Error",
          'No hay tratamientos sin presupuestar. Debe añadir al menos uno desde la pestaña "Odontograma"'
        );
        return;
      }
      this.$refs.showquotation.showNew([], this.data.available_treatments);
    },
    editQuotation(q) {
      this.$refs.showquotation.showEdit(q, this.data.available_treatments);
    },
    approveQuotation(q) {
      if (!q.is_approved) {
        this.errorwindow.show(
          "Confirmación",
          "¿Aprobar el presupuesto?",
          "Aprobar",
          "Cancelar",
          () => {
            this.doApproveQuotation(q);
          }
        );
      } else {
        this.errorwindow.show(
          "Confirmación",
          "¿Retirar la Aprobación del presupuesto? - Esto no modificará la historia médica",
          "Retirar",
          "Cancelar",
          () => {
            this.doUnlockQuotation(q);
          }
        );
      }
    },
    addPayment() {
      this.$refs.showpayment.showNew();
    },
    editPayment(payment) {
      this.$refs.showpayment.showEdit(payment);
    },
    addInvoice() {
      this.$refs.showinvoice.showNew();
    },
    editInvoice(invoice) {
      this.$refs.showinvoice.showEdit(invoice);
    },
    onSubmit() {
      this.selected_treatments = [];
      this.loadData();
    },
    doApproveQuotation(quotation) {
      axios
        .post(
          `/customer/${this.customer.id}/quotation/${quotation.id}/approve`,
          {}
        )
        .then((response) => {
          this.msgwindow.success("Presupuesto aprobado");
        })
        .catch((err) => {
          console.log("[ERR] doApproveQuotation ", err);
          this.msgwindow.error("Error aprobando !");
        })
        .then(() => {
          this.onSubmit();
        });
    },
    doUnlockQuotation(quotation) {
      axios
        .post(
          `/customer/${this.customer.id}/quotation/${quotation.id}/unlock`,
          {}
        )
        .then((response) => {
          this.msgwindow.success("Presupuesto desbloqueado");
        })
        .catch((err) => {
          console.log("[ERR] doUnlockquotation ", err);
          this.msgwindow.error("Error aprobando !");
        })
        .then(() => {
          this.onSubmit();
        });
    },
    loadData() {

      let clinic_id = this.clinic.id;
      if (this.unified_invoices) {
        clinic_id = this.clinic_id;
      }

      let params = {
        clinic_id: clinic_id
      };

      axios
        .get(`/customer/${this.customer.id}/invoices`, { params })
        .then((response) => {
          this.data = response.data;
        })
        .catch((err) => {
          this.msgwindow.error("Error leyendo facturas de cliente");
          console.log("[ERR] loadInvoiceData: ", err);
        });
    },
    nullOrEmpty(array) {
      return !array || array.length == 0;
    },
    getTreatmentTotal(treatment) {
      let quotation = this.filtered_quotations.find((q) => {
        return q.id == treatment.quotation_id;
      });

      if (!quotation) return 0;

      let line = quotation.quotationlines.find((l) => {
        // No product match -> fail
        if (l.product_id != treatment.product_id) return false;
        // Both empty -> ok
        if (this.nullOrEmpty(l.teeth) && this.nullOrEmpty(treatment.teeth))
          return true;
        // Any empty -> fail
        if (this.nullOrEmpty(l.teeth)) return false;
        if (this.nullOrEmpty(treatment.teeth)) return false;

        return (
          l.teeth.filter((x) => {
            return treatment.teeth.indexOf(x) !== -1;
          }).length > 0
        );
      });

      if (!line) return 0;

      return (
        Number(line.price) * (1 - Number(line.discount / 100)) -
        line.abs_discount
      );
    },
    markTreatmentAsPaid(treatment) {
      if (this.is_loading) return;
      this.is_loading = true;
      axios
        .post(`/customer/${this.customer.id}/treatment/${treatment.id}/paid`)
        .then((response) => {
          if (response.data.error) {
            this.msgwindow.error(response.data.error);
          } else {
            this.msgwindow.success("Tratamiento actualizado");
          }
        })
        .catch((error) => {
          console.log("[ERR] markTreatmentAsPaid ", error);
          this.msgwindow.error("Error actualizando tratamiento ");
        })
        .then(() => {
          this.is_loading = false;
        });
    },
    confirmPaidTreatment(treatment) {
      this.msgwindow.info("Buscando precio del tratamiento ...");
      axios
        .get(`/customer/${this.customer.id}/treatment/${treatment.id}/price`)
        .then((response) => {
          let price = response.data.price;
          if (price) {
            this.invoices = response.data.invoices;
            this.$refs.showpayment.showNewTreatment(
              treatment,
              price,
              response.data.invoices
            );
          } else {
            this.is_loading = false;
            this.markTreatmentAsPaid(treatment);
          }
        })
        .catch((error) => {
          console.log("[ERR] confirmPaidTreatment ", error);
          this.msgwindow.error("Error actualizando tratamiento ");
        })
        .then(() => {
          this.is_loading = false;
          this.loadData();
        });
    },
    confirmPaidTreatments(treatments) {
      let prices = treatments.map((t) => {
        return this.getTreatmentTotal(t);
      });

      let quotation_ids = treatments.map((t) => {
        return t.quotation_id;
      });

      let invoices = this.data.invoices.filter((i) => {
        return quotation_ids.includes(i.quotation_id);
      });

      if (this.is_dental) {
        this.$refs.showpayment.showNewTreatments(treatments, prices, invoices);
      } else {
        this.$refs.showpaymentmult.showNewTreatments(
          treatments,
          prices,
          invoices
        );
      }
    },
    payAllTreatments() {
      if (this.is_loading) return;
      this.confirmPaidTreatments(this.selected_treatments);
    },
    paidTreatment(treatment) {
      if (this.is_loading) return;

      if (treatment.status == "done_prior") {
        this.msgwindow.warning(this.done_warning);
        return;
      }

      if (!treatment.quotation_id) {
        this.msgwindow.warning("El tratamiento no se ha presupuestado !");
        return;
      }

      this.is_loading = true;
      this.confirmPaidTreatment(treatment);
    },
    doneTreatment(treatment) {
      if (this.is_loading) return;

      if (treatment.status == "done_prior" && this.clinic.type == "dental") {
        this.msgwindow.warning(this.done_warning);
        return;
      }

      this.is_loading = true;

      axios
        .post(`/customer/${this.customer.id}/treatment/${treatment.id}/done`)
        .then((response) => {
          if (response.data.warning) {
            this.msgwindow.warning(response.data.warning);
          }

          if (response.data.error) {
            this.msgwindow.error(response.data.error);
          } else {
            this.msgwindow.success("Tratamiento actualizado");
          }
        })
        .catch((error) => {
          console.log("[ERR] doneTreatment ", error);
          this.msgwindow.error("Error actualizando tratamiento ");
        })
        .then(() => {
          this.is_loading = false;
          this.loadData();
        });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
.quotation-list,
.invoice-list,
.treatment-list,
.customer-edit-invoices {
  margin-top: 0 15px;
}

.customer-edit-invoices {
  legend {
    font-size: 18px;
    color: var(--theme-text-color);
    font-weight: 500;
    display: inline-block;
    vertical-align: middle;
    width: auto;

    &::before {
      content: "―";
      margin-left: 15px;
      margin-right: 15px;
    }

    &~.btn-wabident-round {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      vertical-align: middle;
      margin-left: 15px;

      svg {
        fill: currentColor;
        width: 15px;
        height: 15px;
        margin-left: 5px;
        display: inline-block;
      }
    }
  }

  &__quotations {
    margin-bottom: 30px;

    .quotation-list {
      margin-top: 30px;
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  &__pending {
    background-color: #fafafa;
    padding: 27px 19px;

    .summary-header {
      font-size: 16px;
      line-height: 1.25;
      color: #3b414b;
    }

    .total-quoted {
      font-size: 14px;
      color: var(--theme-grey);
      font-weight: 500;
    }

    .total-pending {
      font-size: 32px;
      color: var(--theme-text-color);
      font-weight: 800;
      letter-spacing: 0.35px;

      sup {
        font-size: 12px;
      }
    }
  }
}
</style>
